/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCOUNTRY } from './IAPCOUNTRY';
import {
    IAPCOUNTRYFromJSON,
    IAPCOUNTRYFromJSONTyped,
    IAPCOUNTRYToJSON,
} from './IAPCOUNTRY';
import type { IAPTELEPHONECONTACTTYPE } from './IAPTELEPHONECONTACTTYPE';
import {
    IAPTELEPHONECONTACTTYPEFromJSON,
    IAPTELEPHONECONTACTTYPEFromJSONTyped,
    IAPTELEPHONECONTACTTYPEToJSON,
} from './IAPTELEPHONECONTACTTYPE';

/**
 * 
 * @export
 * @interface TelephoneContactViewModel
 */
export interface TelephoneContactViewModel {
    /**
     * 
     * @type {number}
     * @memberof TelephoneContactViewModel
     */
    partyTelephoneContactId?: number;
    /**
     * 
     * @type {number}
     * @memberof TelephoneContactViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {string}
     * @memberof TelephoneContactViewModel
     */
    phoneNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TelephoneContactViewModel
     */
    isPreferredType?: boolean;
    /**
     * 
     * @type {IAPTELEPHONECONTACTTYPE}
     * @memberof TelephoneContactViewModel
     */
    phoneNumberType?: IAPTELEPHONECONTACTTYPE;
    /**
     * 
     * @type {IAPCOUNTRY}
     * @memberof TelephoneContactViewModel
     */
    countryCodeId?: IAPCOUNTRY;
    /**
     * 
     * @type {string}
     * @memberof TelephoneContactViewModel
     */
    countryDialingCode?: string;
}

/**
 * Check if a given object implements the TelephoneContactViewModel interface.
 */
export function instanceOfTelephoneContactViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TelephoneContactViewModelFromJSON(json: any): TelephoneContactViewModel {
    return TelephoneContactViewModelFromJSONTyped(json, false);
}

export function TelephoneContactViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TelephoneContactViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyTelephoneContactId': !exists(json, 'PartyTelephoneContactId') ? undefined : json['PartyTelephoneContactId'],
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'phoneNumber': !exists(json, 'PhoneNumber') ? undefined : json['PhoneNumber'],
        'isPreferredType': !exists(json, 'IsPreferredType') ? undefined : json['IsPreferredType'],
        'phoneNumberType': !exists(json, 'PhoneNumberType') ? undefined : IAPTELEPHONECONTACTTYPEFromJSON(json['PhoneNumberType']),
        'countryCodeId': !exists(json, 'CountryCodeId') ? undefined : IAPCOUNTRYFromJSON(json['CountryCodeId']),
        'countryDialingCode': !exists(json, 'CountryDialingCode') ? undefined : json['CountryDialingCode'],
    };
}

export function TelephoneContactViewModelToJSON(value?: TelephoneContactViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyTelephoneContactId': value.partyTelephoneContactId,
        'PartyId': value.partyId,
        'PhoneNumber': value.phoneNumber,
        'IsPreferredType': value.isPreferredType,
        'PhoneNumberType': IAPTELEPHONECONTACTTYPEToJSON(value.phoneNumberType),
        'CountryCodeId': IAPCOUNTRYToJSON(value.countryCodeId),
        'CountryDialingCode': value.countryDialingCode,
    };
}

